import React from "react";
import "./SalesPackageStyles.scss";
import classNames from "classnames";
import {VehicleGroup} from "../../model/vehicle";
import {VehicleGroupSVG} from "../VehicleGroupSvg";
import {premiumFormat} from "../../utils/format";
import {strings} from "../../strings/strings";
import {SimpleTooltip} from "../SimpleTooltip";
import {ReactSVG} from "react-svg";
import info_red from "../../images/info_red.svg";
import { InstallmentPayment } from "../InstallmentPayment/InstallmentPayment";
import { useMediaQuery } from "@material-ui/core";

interface Props {
    vehicleGroup: VehicleGroup;
    name: string;
    premium: number;
    selected: boolean;
    popular: boolean;
    onSelect: () => void;
    more?: React.ReactElement;
    isSmartDrive?: boolean
    totalPremium: number
}

export const SalesPackage: React.FC<Props> = (props) => {
    const {vehicleGroup, name, premium, totalPremium, selected, popular, onSelect, more, children, isSmartDrive} = props;
    const isMobile = useMediaQuery('(max-width: 1023px)');

    const className = classNames({
        "sales-package": true,
        "sales-package_popular": popular,
        "sales-package_selected": selected
    });

    return (
        <div className={className}>
            <div className='sales-package__top'>
                <div hidden={!popular} className={'sales-package__popular'}>
                    <div className='sales-package__popular__label'>
                        <span>{strings.popular}</span>
                    </div>
                </div>

                <div className={'sales-package__name'}>
                    <VehicleGroupSVG vehicleGroup={vehicleGroup}/>
                    <span>{name}</span>
                </div>

                <div className={'sales-package__premium'}>
                    <div className="align-near">
                        <span>{`${premiumFormat(premium)} ${strings.currencyUAH}`}</span>
                        {isSmartDrive && <SimpleTooltip id={className + '_salesPackageInfo'} title={
                            <span>{strings.salesPackageInfo.text1}<span
                                className={"accent"}>{strings.salesPackageInfo.text2}</span>{strings.salesPackageInfo.text3}<span
                                className={"accent"}>{`${premiumFormat(totalPremium)}`}</span>{strings.salesPackageInfo.text4}</span>}
                                                        placement={"top"}>
                            {<ReactSVG src={info_red}/>}
                        </SimpleTooltip>
                        }
                    </div>
                </div>
                <span className={"sales-package__installment-alt"}>
                    {strings.installmentAlternative}
                </span>
                <InstallmentPayment size={isMobile ? "medium" : "large"}
                                    installmentCount={3}
                                    fullAmount={premium} />
                <div className={'sales-package__options'}>
                    {children}
                </div>
            </div>


            {more && (
                <div className='sales-package__more'>
                    {more}
                </div>
            )}
            <div className='sales-package__select'>
                <button id={className + 'Btn'} onClick={event => onSelect()}>{strings.quotationChoose}</button>
            </div>
        </div>
    )
};
